export default __webpack_public_path__ + "static/media/facebookF.fccf9f58.svg";